"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeRetentionJSONModelFromQueryString = exports.RetentionPageModelProvider = exports.useRetentionPageModelContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const query_string_1 = __importDefault(require("query-string"));
const RetentionJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionJSONModel");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const react_router_dom_1 = require("react-router-dom");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const STATE_QUERY_KEY = "state";
const RetentionPageModelContext = React.createContext(undefined);
const useRetentionPageModelContext = () => {
    const context = React.useContext(RetentionPageModelContext);
    if (!context) {
        throw new Error("useRetentionPageModelContext must be used within a RetentionPageModelContext.Provider");
    }
    return context;
};
exports.useRetentionPageModelContext = useRetentionPageModelContext;
const RetentionPageModelProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [pageModelFormState, setPageModelFormState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, exports.deserializeRetentionJSONModelFromQueryString)(location.search).serialize());
    ////////////////////////////////////////////////
    // Update page model on page URL change
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            const jsonModel = (0, exports.deserializeRetentionJSONModelFromQueryString)(location.search);
            if (!jsonModel.getTabsJSONModel().hasItems()) {
                jsonModel.getTabsJSONModel().addEmptyTab(true);
            }
            setPageModelFormState(jsonModel.serialize());
        }
    }, [projectApiKey, location.search, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get Form JSON Model
    ////////////////////////////////////////////////
    const getFormJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new RetentionJSONModel_1.RetentionJSONModel(pageModelFormState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Period Changed
    ////////////////////////////////////////////////
    const onPeriodChanged = (0, use_custom_compare_1.useCustomCompareCallback)((last) => {
        const jsonModel = new RetentionJSONModel_1.RetentionJSONModel(pageModelFormState);
        jsonModel.getPeriodDaysJSONModel().setLast(last);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Retention Type Changed
    ////////////////////////////////////////////////
    const onRetentionTypeChanged = (0, use_custom_compare_1.useCustomCompareCallback)((retentionType) => {
        const jsonModel = new RetentionJSONModel_1.RetentionJSONModel(pageModelFormState);
        jsonModel.getRetentionTypeJSONModel().setType(retentionType);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Tabs Changed
    ////////////////////////////////////////////////
    const onTabsChanged = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        // console.log("onTabsChanged!");
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Events Changed
    ////////////////////////////////////////////////
    const onEventsChanged = (0, use_custom_compare_1.useCustomCompareCallback)((eventsSerializedState, context) => {
        // console.log("onEventsChanged!", {eventsSerializedState, context});
        const jsonModel = new RetentionJSONModel_1.RetentionJSONModel(pageModelFormState);
        const activeTabUniqueId = context === null || context === void 0 ? void 0 : context.activeTabUniqueId;
        const queryEventVariantsJSONModel = (context === null || context === void 0 ? void 0 : context.query) === "cohort" ?
            jsonModel.getTabsJSONModel().getCohortJSONModel(activeTabUniqueId) :
            jsonModel.getTabsJSONModel().getReturnJSONModel(activeTabUniqueId);
        queryEventVariantsJSONModel === null || queryEventVariantsJSONModel === void 0 ? void 0 : queryEventVariantsJSONModel.overwriteFromSerializedState(eventsSerializedState);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Show action
    ////////////////////////////////////////////////
    const show = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        if (isMounted()) {
            //model from location query
            const modelFromLocationQuery = (0, exports.deserializeRetentionJSONModelFromQueryString)(location.search);
            //passed model from UI
            const jsonModel = new RetentionJSONModel_1.RetentionJSONModel(pageModelFormState);
            //compare if there are differences
            const isEqualState = lodash_1.default.isEqual(modelFromLocationQuery.serialize(), jsonModel.serialize());
            //bump sequence to redraw UI
            jsonModel.getSequenceJSONModel().bumpValue();
            const serializedState = RetentionJSONModel_1.RetentionJSONModel.makeModelStateClean(jsonModel.serialize());
            //generate new URL
            const newUrl = AppRouting_1.AppPathGenerator.Project.retention(projectApiKey, serializedState);
            if (isEqualState) {
                history.replace(newUrl);
            }
            else {
                history.push(newUrl);
            }
        }
    }, [projectApiKey, pageModelFormState, location.search, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const pageModelStateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getFormJSONModel,
        show,
        onPeriodChanged,
        onRetentionTypeChanged,
        onTabsChanged,
        onEventsChanged,
    }), [getFormJSONModel, show, onPeriodChanged, onRetentionTypeChanged, onTabsChanged, onEventsChanged], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        pageModelFormState,
        pageModelStateFns,
    }), [
        pageModelFormState,
        pageModelStateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(RetentionPageModelContext.Provider, { value: value }, props.children);
};
exports.RetentionPageModelProvider = RetentionPageModelProvider;
const deserializeRetentionJSONModelFromQueryString = (query) => {
    const queryParams = query_string_1.default.parse(query);
    const modelStateSerialized = queryParams[STATE_QUERY_KEY];
    const jsonModel = new RetentionJSONModel_1.RetentionJSONModel();
    jsonModel.overwriteFromSerializedStateString(modelStateSerialized);
    return jsonModel;
};
exports.deserializeRetentionJSONModelFromQueryString = deserializeRetentionJSONModelFromQueryString;
